import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { DropdownSelector } from '@bingads-webui-react/dropdown-selector';

export class GranularityPicker extends React.PureComponent {
  render() {
    const selectedItem = (!_.isUndefined(this.props.selectedItem)) ?
      _.findWhere(this.props.allGranularities, { id: this.props.selectedItem.id }) :
      undefined;

    return (!_.isUndefined(this.props.selectedItem)) ? (
      <div className={this.props.class} >
        <DropdownSelector
          selectedItem={selectedItem}
          onSelect={this.props.onChangeHandler}
          totalCount={(this.props.allGranularities).length}
          items={this.props.allGranularities}
          i18n={this.props.i18n}
          dropdownMenuAriaLabel={this.props.i18n.getString('BI_Chart_GranularityPicker')}
          enableArrowKeysSupport
          shouldFocusFirstFocusableItemOnMount
        />
      </div>
    ) : null;
  }
}

GranularityPicker.propTypes = {
  allGranularities: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  selectedItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  }),
  class: PropTypes.string,
  /**
   * i18n for localization
   */
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
};

GranularityPicker.defaultProps = {
  class: 'granularity-picker',
  selectedItem: undefined,
};
